import { Injectable, inject } from "@angular/core";
import { AppConfig } from "../config/app.config";
import { HttpClient } from "@angular/common/http";
import { BrokerCompanyResponse, BrokerResponse, BrokerStateResponse, BrokerUserResponse, inceptionStatusMap, InceptionStatusResponse, QuoteOwnerResponse, StatusListResponse, StatusMap, UserNameList, UWAdminResponse } from "../models/QuoteList";
import { AuthService } from "../auth/auth.service";


@Injectable({
    providedIn: 'root'
})
export class BrokerQuoteService {
    private apiUrl = AppConfig.apiUrl;
    httpClient = inject(HttpClient);
    // private token = AppConfig.token;
    authservice = inject(AuthService)       
    private token = this.authservice.getToken()

    fetchAllQuoteList(pageNumber: number, pageSize: number, sortingParams: { [key: string]: string | number | null }) {
      const path = `/api/BrokerHome`;
      const encodedPath = encodeURIComponent(path);
      let url = `${this.apiUrl}/Proxy?path=${encodedPath}`;
      const query = this.buildProxyQuery({
        pagenumber: pageNumber,
        numOfRecord: pageSize,
        ...sortingParams
      });
  
      if (query) {
          // Encode once for proxy and preserve commas for multi-value params
          url += '?' + encodeURIComponent(query);
      }
      return this.httpClient.get<BrokerResponse>(url);
  }
  

    private buildFilterQuery(params: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] }): string {
      const parts: string[] = [];
      if (params?.companyIds && params.companyIds.length) {
        parts.push(params.companyIds.map(id => `companyIds=${id}`).join('&'));
      }
      if (params?.userIds && params.userIds.length) {
        parts.push(params.userIds.map(id => `userIds=${id}`).join('&'));
      }
      if (params?.statusIds && params.statusIds.length) {
        parts.push(params.statusIds.map(id => `statusIds=${id}`).join('&'));
      }
      if (params?.stateIds && params.stateIds.length) {
        parts.push(params.stateIds.map(id => `stateIds=${id}`).join('&'));
      }
      if (params?.branchIds && params.branchIds.length) {
        parts.push(params.branchIds.map(id => `branchIds=${id}`).join('&'));
      }
      return parts.filter(Boolean).join('&');
    }

    fetchBrokerCompanyList(filters?: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] }) {
      let path=`/api/UWAdmin/GetCompanyList`;
      const query = this.buildFilterQuery(filters || {});
      if (query) {
        path += `?${query}`;
      }
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<BrokerCompanyResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    fetchBrokerUserList(filters?: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] }) {
      let path = `/api/UWAdmin/GetBrokerNameList`;
      const query = this.buildFilterQuery(filters || {});
      if (query) {
        path += `?${query}`;
      }
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<BrokerUserResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

     fetchBrokerStatus(filters?: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] }) {
      let path = `/api/UWAdmin/GetStatusList`;
      const query = this.buildFilterQuery(filters || {});
      if (query) {
        path += `?${query}`;
      }
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<StatusListResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    
    fetchBrokerState(filters?: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] }){
      let path=`/api/UWAdmin/GetStateList`;      
      const query = this.buildFilterQuery(filters || {});
      if (query) {
        path += `?${query}`;
      }
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<BrokerStateResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    fetchQuoteOwnerList(companyId: string, branchId: string, filters?: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] }) {
      let path=`/api/UserMaster/GetUsersByCompanyAndBranch/${companyId}/branch/${branchId}`
      const query = this.buildFilterQuery(filters || {});
      if (query) {
        path += `?${query}`;
      }
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<QuoteOwnerResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    fetchQuoteListForUWAdmin(pageNumber: number, pageSize: number, additionalParams: { [key: string]: string | number | null }) {
      const path = `/api/UWAdmin`;
      const encodedPath = encodeURIComponent(path);
  
      let url = `${this.apiUrl}/Proxy?path=${encodedPath}`;
      const query = this.buildProxyQuery({
        pageNumber: pageNumber,
        numOfRecord: pageSize,
        ...additionalParams
      });
  
      if (query) {
          // Encode once for proxy and preserve commas for multi-value params
          url += '?' + encodeURIComponent(query);
      }
      return this.httpClient.get<UWAdminResponse>(url);
  }

  SaveQuoteNJTN(payload:any){
    const path=`/api/Policy/SaveQuoteNJTN`;
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.post<any>(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
  }
  
  GetQuoteNJTN(quoteId:number){
    const path=`/api/Policy/GetQuoteNJTN?quoteId=${quoteId}`;
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get<any>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
  }

  SavePolicyNJTN(payload:any){    
    const path=`/api/Policy/SavePolicyNJTN`;
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.post<any>(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
  }

  GetPolicyNJTN(policyId:number){
    const path=`/api/Policy/GetPolicyNJTN?policyId=${policyId}`;
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get<any>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
  } 
    
    isUwAdmin(): boolean {
      const role = sessionStorage.getItem('role');
      return role === "2";
    }

    // setCurrentStepId(stepId: string): void{
    //     switch(stepId){
    //       case "1":
    //         sessionStorage.setItem('currentStepId', "0");
           
    //         break;
    //       case "2":
    //         sessionStorage.setItem('currentStepId', "1");
    //         sessionStorage.setItem("copeInfosave","false")
    //         break;
    //       case "3":
    //         sessionStorage.setItem('currentStepId', "2");
    //         sessionStorage.setItem("copeInfosave","true")
    //         sessionStorage.setItem("PolicyInfoSave","false")
    //         break;
    //       case "4":
    //         sessionStorage.setItem('currentStepId', "3");
    //         sessionStorage.setItem("copeInfosave","true")
    //         sessionStorage.setItem("PolicyInfoSave","true")
    //         break;
    //       case "5":
    //         sessionStorage.setItem('currentStepId', "4");
    //         break;
    //       default:
    //         sessionStorage.setItem('currentStepId', "0");
    //     }
    //   }

    setCurrentStepId(stepId: string): void{
      switch(stepId){
        case "1": // clearance
          sessionStorage.setItem('currentStepId', "0");    
          sessionStorage.setItem("copeInfosave","false")     
          break;
        case "2": // cope
          sessionStorage.setItem('currentStepId', "1");
          sessionStorage.setItem("copeInfosave","true")
          sessionStorage.setItem("PolicyInfoSave","false")         
          break;
        case "3": // policy parameter
          sessionStorage.setItem('currentStepId', "2");
          sessionStorage.setItem("copeInfosave","false")
          sessionStorage.setItem("PolicyInfoSave","true")
          break;
        case "4a":
          sessionStorage.setItem('currentStepId', "3");
          sessionStorage.setItem('indicationBindStepId', "1");
          sessionStorage.setItem("copeInfosave","true")
          sessionStorage.setItem("PolicyInfoSave","true")
          break;
        case "4b":
          sessionStorage.setItem('currentStepId', "3");
          sessionStorage.setItem('indicationBindStepId', "2");
          sessionStorage.setItem("copeInfosave","true")
          sessionStorage.setItem("PolicyInfoSave","true");
          sessionStorage.setItem("terms","true")
          break;
        case "4c":
          sessionStorage.setItem('currentStepId', "3");
          sessionStorage.setItem('indicationBindStepId', "3");
          sessionStorage.setItem("copeInfosave","true")
          sessionStorage.setItem("PolicyInfoSave","true")
          break; 
        case "4d":
          sessionStorage.setItem('currentStepId', "3");
          sessionStorage.setItem('indicationBindStepId', "4");
          sessionStorage.setItem("copeInfosave","true")
          sessionStorage.setItem("PolicyInfoSave","true")
          break;         
        case "5":
          sessionStorage.setItem('currentStepId', "4");
          sessionStorage.setItem("copeInfosave","true");
          sessionStorage.setItem("PolicyInfoSave","true");
          break;
        default:
          sessionStorage.setItem('currentStepId', "0");
      }
    }

    setIndicationBindStepId(stepId: string): void{
        switch(stepId){
          case "1":
            sessionStorage.setItem('indicationBindStepId', "1");
            break;
          case "2":
            sessionStorage.setItem('indicationBindStepId', "2");
            break;
          case "3":
            sessionStorage.setItem('indicationBindStepId', "3");
            break;
          case "4":
            sessionStorage.setItem('indicationBindStepId', "4");
            break;
          default:
            sessionStorage.setItem('indicationBindStepId', "1");
        }
    }

    getIndicationBindStepId(): string {
      return sessionStorage.getItem('indicationBindStepId') || "1";
    }

    private buildProxyQuery(additionalParams: { [key: string]: string | number | null | undefined }): string {
        const parts: string[] = [];
        for (const [key, value] of Object.entries(additionalParams)) {
          if (value !== null && value !== undefined) {
            const encodedValue = encodeURIComponent(value.toString()).replace(/%2C/g, ',');
            parts.push(`${key}=${encodedValue}`);
          }
        }
        return parts.join('&');
    }

    setStatusList(statusData: StatusListResponse[]) {
      const transformedData: StatusMap = {};
      statusData.forEach((item) => {
        transformedData[item.code] = {
          gencodeId: item.gencodeId,
          code: item.code,
        };
      });
      sessionStorage.setItem('statusList', JSON.stringify(transformedData));
    }

    setInceptionStatusList(InceptionStatusData : InceptionStatusResponse[]){
      const transformedData: inceptionStatusMap = {};
      InceptionStatusData.forEach((item) => {
        transformedData[item.code] = {
          gencodeId: item.gencodeId,
          code: item.code,
          description : item.description,
        };
      });
      sessionStorage.setItem('InceptionstatusList', JSON.stringify(transformedData));
    }

    setUsersNameList(usersList: UserNameList[]) {
      sessionStorage.setItem('userNamesList', JSON.stringify(usersList));
    }

    getUsersNameList() {
      const storedData = sessionStorage.getItem('userNamesList');
      if (storedData) {
        return JSON.parse(storedData);
      }
      return [];
    }

    setStatusId(statusId: number) {
      sessionStorage.setItem('statusId', String(statusId));
    }

    setInceptionStatusId(InceptionStatusCode: String){
      sessionStorage.setItem('InceptionStatusCode', String(InceptionStatusCode));
    }

    getStatusId(){
      return sessionStorage.getItem('statusId');
    }

    getInceptionStatusCode(){
      return sessionStorage.getItem('InceptionStatusCode');

    }

    getStatusListFromStorage() {
      const storedData = sessionStorage.getItem('statusList');
      if (storedData) {
        return JSON.parse(storedData);
      }
      return null;
    }

    getInceptionStatusListFromStorage() {
      const storedData = sessionStorage.getItem('InceptionstatusList');
      if (storedData) {
        return JSON.parse(storedData);
      }
      return null;
    }
}